<div class="address-form-wrapper">
  <a routerLink="/viewCart">Skip Address</a>
  <h2>Add New Address</h2>

  <form (ngSubmit)="submitForm()" #addressForm="ngForm">
    <div class="form-grid">
      <div class="form-group">
        <label>Name</label>
        <input type="text" name="name" [(ngModel)]="address.name" required />
      </div>

      <div class="form-group">
        <label>Phone</label>
        <input type="tel" name="contact" [(ngModel)]="address.contact" required />
      </div>

     

      <div class="form-group full">
        <label>Address</label>
        <input type="text" name="address" [(ngModel)]="address.address" required />
      </div>

       <div class="form-group">
        <label>Email</label>
        <input type="text" name="email" [(ngModel)]="address.email" required />
      </div>

      <div class="form-group">
        <label>Street</label>
        <input type="text" name="street" [(ngModel)]="address.street" required />
      </div>

      <div class="form-group">
        <label>City</label>
        <input type="text" name="city" [(ngModel)]="address.city" required />
      </div>

      <div class="form-group">
        <label>State</label>
        <input type="text" name="state" [(ngModel)]="address.state" required />
      </div>

      <div class="form-group">
        <label>ZIP Code</label>
        <input type="text" name="pincode" [(ngModel)]="address.pincode" required />
      </div>

      <div class="form-group">
        <label>Country</label>
        <input type="text" name="country" [(ngModel)]="address.country" disabled />
      </div>

       <div class="form-group">
        <label>Landmark</label>
        <input type="text" name="landmark" [(ngModel)]="address.landmark" required />
      </div>


      <div class="form-group">
        <label>Address Label</label>
        <select name="label" [(ngModel)]="address.address_type" required>
          <option value="Home">Home</option>
          <option value="Office">Office</option>
          <option value="Other">Other</option>
        </select>
      </div>
    </div>

    <button type="submit" class="submit-btn">Save Address</button>
  </form>
</div>
